"use client";

import { useUser } from "@/app/_providers/user";
import { logger } from "@utilities/logger";
import { IS_LOCAL } from "@/env";
import { Button } from "@components/core/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@components/core/DialogWrapper";
import { useEffect, useState } from "react";
import { inPrivacyStates, optOutCCPA } from "@/app/_utilities/ccpa";

export function CCPAOptOut(props: React.ComponentPropsWithoutRef<"button">) {
  const [isInPrivacyState, setIsInPrivacyState] = useState(false);
  const [isOptOutDialogOpen, setIsOptOutDialogOpen] = useState(false);

  const { isLoggedIn } = useUser();

  useEffect(() => {
    const checkPrivacyState = async () => {
      const privacyState = await inPrivacyStates();
      setIsInPrivacyState(privacyState);
    };

    checkPrivacyState().catch(err => logger.error(err instanceof Error ? err : null, "checkPrivacyState failed"));
  }, []);

  const showOptOutCCPAButton = isInPrivacyState || IS_LOCAL;

  if (!showOptOutCCPAButton) {
    return null;
  }

  return (
    <Dialog onOpenChange={setIsOptOutDialogOpen} open={isOptOutDialogOpen}>
      <DialogTrigger asChild>
        <button type='button' onClick={() => setIsOptOutDialogOpen(true)} {...props} />
      </DialogTrigger>
      <DialogContent className='m-8 max-w-3xl rounded-xl p-24'>
        <DialogHeader>
          <DialogTitle>Opt out of Sale/Share/Targeted Advertising</DialogTitle>
        </DialogHeader>
        <DialogDescription className='my-8 py-16 text-sm'>
          When we share Personal Data through our marketing cookies or with vendors that provide advertising services to
          us, these disclosures may be considered a sale or sharing for cross-context behavioral advertising, or
          targeted advertising under certain U.S. state privacy laws. If you would like to opt-out, please click the
          opt-out button below. Please note that we use cookies to remember your preference and if you clear cookies in
          your browser, you will need to opt out again. If you do not have an ElevenLabs account, or are not logged in
          to your account, this setting will only apply to the browser you are currently using. For more information on
          how we collect, use, and disclose your personal information, please see our Privacy Policy.
        </DialogDescription>
        <DialogFooter>
          <div className='flex gap-x-8'>
            <Button onClick={() => setIsOptOutDialogOpen(false)} variant='secondary'>
              Cancel
            </Button>
            <Button
              onClick={() =>
                optOutCCPA({ isLoggedIn, shouldReload: true }).catch(err =>
                  logger.error(err instanceof Error ? err : null, "optOutCCPA failed"),
                )
              }
              variant='primary'
            >
              Opt Out
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
